import n, { createContext as c, useContext as i, forwardRef as u } from "react";
const a = c(
  void 0
);
function s() {
  const t = i(a);
  return t || l;
}
const l = u(function(e, o) {
  const r = typeof e.href == "string" ? e.href : e.href.href ?? "";
  if (!r)
    return /* @__PURE__ */ n.createElement(n.Fragment, null, e.children);
  const f = { ...e };
  return delete f.prefetch, /* @__PURE__ */ n.createElement("a", { ...f, href: r, ref: o });
});
export {
  a as L,
  s as u
};
//# sourceMappingURL=LinkContext-0c83848a.mjs.map
